







import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: {
    PageTitle,
    AdminIframe,
  },
})
export default class AppList extends Vue {
  private remoteSrc = '';

  private setRemoteSrc() {
    const queryObject = { ...this.$route.query, serviceType: 'PREMIUM' };

    const pathName = this.$route.path.split('/').at(-1);

    const queryString = new URLSearchParams(queryObject).toString();
    this.remoteSrc = process.env.VUE_APP_ADMIN_REMOTE_URL + `/statistic/sales/${pathName}?` + queryString;
  }

  created() {
    this.setRemoteSrc();
  }
}
